import React, { useState, useEffect, useContext } from 'react'
import styles from '../../styles/Register.module.scss'
import axios from 'axios'
import { useRouter } from 'next/router'
import { createClient } from 'graphqurl'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import {
	Form,
	Row,
	Col,
	Button,
	Alert,
	Spinner,
	InputGroup,
	FormControl
} from 'react-bootstrap'

import UserContext from '../../UserContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash, faLock } from '@fortawesome/free-solid-svg-icons'
import { faEye } from '@fortawesome/free-regular-svg-icons'

export default function AvailabilityStatus({ setCurrentStep, inputs, setInputs, confirmPw, setConfirmPw, experiences, educations, boolean, setBoolean, imgData, cvData, experienceIds, educationIds }): JSX.Element {
	const { currentlyEmployed, startWorkImmediately, broadcastToEmployers } = boolean
	const { t } = useTranslation()
	const [show, setShow] = useState(false)
	const [disable, setDisable] = useState(true)
	const [showAlert, setShowAlert] = useState(false)
	const [showPass, setShowPass] = useState(false)
	const [showConfPass, setShowConfPass] = useState(false)

	// for loading "message"
	const [showLoading, setShowLoading] = useState(false)

	const { user, setUser } = useContext(UserContext)

	const router = useRouter()
	const source = router.query.source
	const pathName = router.pathname

	const handleInsert = async (event): Promise<void> => {
		event.preventDefault()
		event.stopPropagation()

		if (currentlyEmployed !== '' && startWorkImmediately !== '' && broadcastToEmployers !== '') {
			setShowLoading(true)

			const res: any = await axios.post(process.env.NEXT_PUBLIC_SIGNUP_ROUTE as string, {
				...inputs, experiences, educations
			})
			// .catch(err => console.error(err))

			const obj = res.data
			if (obj.applicant !== undefined && obj.token !== undefined) {
				if (cvData !== undefined || imgData !== undefined) {
					const form = new window.FormData()
					form.append('id', obj.applicant.id)
					// Should be using original contact instead of new
					form.append('contact', inputs.contact)
					if (cvData !== undefined) form.append('cv', cvData)
					if (imgData !== undefined) form.append('avatar', imgData)
					const uploadRes: any = await axios.post(process.env.NEXT_PUBLIC_UPLOAD_ENDPOINT as string, form, {
						headers: { 'Content-Type': 'multipart/form-data' }
					})
					// Upload succeeded
					if (uploadRes.status === 200 && uploadRes.data === true) {
						window.localStorage.setItem('token', obj.token)
						window.localStorage.setItem('profile', JSON.stringify(obj.applicant))

						setUser(obj.applicant)

						if (typeof router.query.redirect !== 'undefined') {
							router.push(router.query.redirect as string)
								.catch(() => null)
						} else {
							router.push('/profile-completed')
								.catch(() => null)
						}
					}
				} else {
					// didn't upload
					window.localStorage.setItem('token', obj.token)
					window.localStorage.setItem('profile', JSON.stringify(obj.applicant))

					setUser(obj.applicant)

					if (typeof router.query.redirect !== 'undefined') {
						router.push(router.query.redirect as string)
							.catch(() => null)
					} else {
						router.push('/profile-completed')
							.catch(() => null)
					}
				}
			} else if (obj.isTaken === true) {
				setShowAlert(true)
				setShowLoading(false)
			}
		}
	}

	const handleUpdate = async (event): Promise<void> => {
		event.preventDefault()
		event.stopPropagation()

		// if all required fields are filled
		if (currentlyEmployed !== '' && startWorkImmediately !== '' && broadcastToEmployers !== '') {
			const token = window.localStorage.getItem('token')

			const updatePassword = {
				password: inputs.password,
				id: user.id,
				token: token
			}

			if (cvData !== undefined || imgData !== undefined) {
				const form = new window.FormData()
				form.append('id', user.id)
				// Should be using original contact instead of new
				form.append('contact', user.contact)
				if (cvData !== undefined) form.append('cv', cvData)
				if (imgData !== undefined) form.append('avatar', imgData)
				const res: any = await axios.post(process.env.NEXT_PUBLIC_UPLOAD_ENDPOINT as string, form, {
					headers: { 'Content-Type': 'multipart/form-data' }
				})
				// Want handleSubmit to stop if upload fails
				if (!(res.status === 200 && res.data === true)) {
					// May return "message"
					return
				}
			}

			if (inputs.cvName.includes('file selected') === true) inputs.cvName = null
			if (inputs.unemployedDuration === '') inputs.unemployedDuration = null
			if (inputs.locationMrt === null || inputs.locationMrt === '') {
				inputs.locationMrt = null
				inputs.locationOther = 'Not in Singapore'
			} else {
				const splitArr = inputs.locationMrt.split(' ')

				let stationName = ''
				for (let i = 1; i < splitArr.length; i++) {
					if (i === 1) stationName = stationName + splitArr[i]
					else stationName = stationName + ' ' + splitArr[i]
				}

				inputs.locationMrt = splitArr[0]
				inputs.locationOther = stationName
			}
			if (inputs.workPass === null || inputs.workPass === 'null' || inputs.workPass === '') inputs.workPass = null
			if (inputs.whatsapp === '') inputs.whatsapp = null
			inputs.age = moment().diff(moment(inputs.dateOfBirth, 'YYYYMMDD'), 'years')
			inputs.education = inputs.educationLevel !== 'OTHERS' ? inputs.educationLevel : inputs.education

			delete inputs.avatar
			delete inputs.cv
			delete inputs.password
			delete inputs.__typename

			const filteredArr = experiences.filter(experience => typeof experience.id === 'string')
			const filterEducationArr = educations.filter(experience => typeof experience.id === 'string')

			const objects = filteredArr.map(experience => {
				// experience.applicantId = user.id
				delete experience.id
				experience.occupation = parseInt(experience.occupation)
				if (experience.endDate === '') experience.endDate = null
				if (experience.description === '') experience.description = null
				return experience
			})
			const educationObjects = filterEducationArr.map(ele => {
				const educationEnums = ['ALEVEL', 'DEGREE', 'DIPLOMA', 'HIGHERNITEC', 'NITEC', 'NLEVEL', 'OLEVEL', 'PSLE', 'SEC']
				// const getEducationEnum = (): string => {
				//   if (educationEnums.includes(ele.educationLevel)) return ele.education
				//   else return 'OTHERS'
				// }
				ele.educationLevel = educationEnums.includes(ele.educationLevel) ? ele.educationLevel : 'OTHERS'
				ele.educationOther = educationEnums.includes(ele.educationLevel) ? null : ele.educationDisplay
				ele.startYear = parseInt(ele.startYear)
				ele.endYear = parseInt(ele.endYear)
				if (ele.description === '') ele.description = null
				if (ele.grade === 0) ele.grade = null
				delete ele.id
				delete ele.educationDisplay
				return ele
			})

			try {
				const client = createClient({
					endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
					headers: {
						authorization: token ? `Bearer ${token}` : ''
					}
				})
				const hasuraMutation = client.query({
					query: `
          mutation ($id: Int!, $changes: Applicant_set_input, $objects: [ApplicantExperience_insert_input!]!, $educationObjects: [ApplicantEducation_insert_input!]!, $experienceIds: [Int!], $educationIds: [Int!]) {
            update_Applicant_by_pk(pk_columns: {id: $id} _set: $changes) {
              id
              name
              email
              avatar
              contact
            }
            insert_ApplicantExperience(objects: $objects) {
              affected_rows
            }
            insert_ApplicantEducation(objects: $educationObjects) {
              affected_rows
            }
            update_ApplicantExperience(where: {
              id: {_in: $experienceIds}
            } _set: { isDeleted: true}) {
              affected_rows
            }
            update_ApplicantEducation(where: {
              id: {_in: $educationIds}
            } _set: { isRemoved: true}) {
              affected_rows
            }
          }
          `,
					variables: {
						id: user.id,
						changes: inputs,
						objects,
						educationObjects,
						experienceIds,
						educationIds
					}
				})

				const hasuraRes = await hasuraMutation

				const { insert_ApplicantExperience: insertedExperiences, update_ApplicantExperience: updatedExperiences } = hasuraRes.data
				window.localStorage.setItem('profile', JSON.stringify(hasuraRes.data.update_Applicant_by_pk))

				// Mutation succeed
				if (insertedExperiences.affected_rows === objects.length && updatedExperiences.affected_rows === experienceIds.length) {
					if (user.email !== null) {
						if (typeof router.query.redirect !== 'undefined') {
							router.push(router.query.redirect as string)
								.catch(() => null)
						} else {
							router.push('/profile')
								.catch(() => null)
						}
					}
				}

				if (user.email === null) {
					// updatePassword
					axios.post(process.env.NEXT_PUBLIC_SIGNUP_UPDATE_PASSWORD as string, updatePassword).then(() => {
						const tempUser = user
						tempUser.email = inputs.email
						setUser(tempUser)
						if (typeof router.query.redirect !== 'undefined') {
							router.push(router.query.redirect as string)
								.catch(() => null)
						} else {
							if (source === 'broadcast') {
								router.push('/broadcast-success').catch(() => null)
							} else {
								router.push('/browse-jobs').catch(() => null)
							}
						}
					}).catch(() => null)
				}
			} catch (err) {
				// console.error(err)
			}
		}
	}

	useEffect(() => {
		if (inputs.password !== undefined && confirmPw !== undefined) {
			if (inputs.password.length !== 0 && confirmPw.length !== 0) {
				if (inputs.password !== confirmPw) {
					setShow(true)
					setDisable(true)
				} else {
					setShow(false)
					setDisable(false)
				}
			}
		}
	}, [inputs.password, confirmPw])

	return (
		<Form onSubmit={user === null ? handleInsert : handleUpdate}>
			<Row className='mb-3'>
				<Col sm={12} md={6}>
					<Form.Group>
						<Form.Label>
							{t('update_profile.are_you_currently_employed')}
							<span className={styles.mandatory}>*</span>
						</Form.Label>
						<div>
							<Button
								variant={currentlyEmployed === 'true' ? 'danger' : 'light'}
								className={styles.selectItem}
								onClick={() => {
									setBoolean({ ...boolean, currentlyEmployed: 'true' })
									setInputs({ ...inputs, isEmployed: true, unemployedDuration: '' })
								}}
							>
								{t('update_profile.yes')}
							</Button>
							<Button
								// variant={currentlyEmployed === 'false' ? 'danger' : 'light'}
								variant={currentlyEmployed === 'false' ? 'danger' : 'light'}
								onClick={() => {
									setBoolean({ ...boolean, currentlyEmployed: 'false' })
									setInputs({ ...inputs, isEmployed: false })
								}}
							>
								{t('update_profile.no')}
							</Button>
						</div>
					</Form.Group>
				</Col>
				{currentlyEmployed === 'false' && (
					<Col sm={12} md={6}>
						<Form.Group>
							<Form.Label>
								{t('update_profile.how_long_have_you_been_unemployed')}
								<span className={styles.mandatory}>*</span>
							</Form.Label>
							<Form.Select
								as='select'
								value={inputs.unemployedDuration}
								onChange={event => {
									setInputs({
										...inputs,
										unemployedDuration: event.target.value
									})
								}}
								required
							>
								<option value='' disabled>{t('update_profile.choose_an_option')}</option>
								<option value='<3m'>{t('update_profile.less_than3_months')}</option>
								<option value='3m6m'>{t('update_profile.3_6_months')}</option>
								<option value='>6m'>{t('update_profile.more_than_6')}</option>
							</Form.Select>
						</Form.Group>
					</Col>
				)}
			</Row>
			<Row className='mb-3'>
				<Col>
					<Form.Group>
						<Form.Label>
							{t('update_profile.are_you_able_to_start_work_immediately')}
							<span className={styles.mandatory}>*</span>
						</Form.Label>
						<div>
							<Button
								variant={startWorkImmediately === 'true' ? 'danger' : 'light'}
								className={styles.selectItem}
								onClick={() => {
									setBoolean({ ...boolean, startWorkImmediately: 'true' })
									setInputs({ ...inputs, isStartWorkNow: true })
								}}
							>
								{t('update_profile.yes')}
							</Button>
							<Button
								variant={startWorkImmediately === 'false' ? 'danger' : 'light'}
								onClick={() => {
									setBoolean({ ...boolean, startWorkImmediately: 'false' })
									setInputs({ ...inputs, isStartWorkNow: false })
								}}
							>
								{t('update_profile.no')}
							</Button>
						</div>
					</Form.Group>
				</Col>
			</Row>

			{(source !== 'broadcast' && pathName !== '/update-profile') && (
				<Row className='mb-3'>
					<Col>
						<Form.Group>
							<Form.Label>
								{t('update_profile.broadcast_to_employers')}
								<span className={styles.mandatory}>*</span>
							</Form.Label>
							<div>
								<Button
									variant={broadcastToEmployers === 'true' ? 'danger' : 'light'}
									className={styles.selectItem}
									onClick={() => {
										setBoolean({ ...boolean, broadcastToEmployers: 'true' })
										setInputs({
											...inputs,
											broadcastStartDate: moment().format(),
											broadcastEndDate: moment().add(1, 'years').format()
										})
									}}
								>
									{t('update_profile.yes')}
								</Button>
								<Button
									variant={broadcastToEmployers === 'false' ? 'danger' : 'light'}
									onClick={() => {
										setBoolean({ ...boolean, broadcastToEmployers: 'false' })
										setInputs({
											...inputs,
											broadcastStartDate: null,
											broadcastEndDate: null
										})
									}}
								>
									{t('update_profile.no')}
								</Button>
							</div>
						</Form.Group>
					</Col>
				</Row>
			)}

			<hr className='mb-5' />
			{(user === null || user.email === null) && (
				<>
					<h3 className='text-center mb-3'>{t('update_profile.create_password')}</h3>
					<Row>
						<Col>
							<Form.Group>
								<Form.Label>
									{t('update_profile.email')}
									<span className={styles.mandatory}>*</span>
								</Form.Label>
								<Form.Control
									className={styles.formControl}
									type='email'
									value={inputs.email}
									onChange={event => {
										setInputs({
											...inputs,
											email: event.target.value
										})
									}}
									required
									pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
								/>
							</Form.Group>
						</Col>
					</Row>
					{showAlert && (
						<Alert
							variant='danger'
							onClose={() => setShowAlert(false)}
							dismissible
						>
							{t('update_profile.email_taken')}
						</Alert>
					)}
					<Row className='mb-3 mt-3'>
						<Col sm={12} md={6} className='mb-3'>
							<InputGroup>
								<InputGroup.Text style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px', backgroundColor: 'white', borderRight: '0px', borderColor: '#EBEBEB' }}>
									<FontAwesomeIcon icon={faLock} />
								</InputGroup.Text>
								<FormControl
									placeholder={t('login.password')}
									style={{ borderLeft: '0px', borderColor: '#EBEBEB' }}
									type={showPass ? 'text' : 'password'}
									value={inputs.password}
									onChange={event => {
										setInputs({
											...inputs,
											password: event.target.value
										})
									}}
									required
									pattern='.{8,}'
								/>

								<InputGroup.Text style={{ backgroundColor: 'white', borderBottomRightRadius: '10px', borderLeft: '0px', borderTopRightRadius: '10px', borderColor: '#EBEBEB' }}>
									{showPass ? <FontAwesomeIcon icon={faEyeSlash} onClick={() => setShowPass(false)} /> : <FontAwesomeIcon icon={faEye} onClick={() => setShowPass(true)} />}
								</InputGroup.Text>

							</InputGroup>
						</Col>
						<Col>
							<InputGroup>
								<InputGroup.Text style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px', backgroundColor: 'white', borderRight: '0px', borderColor: '#EBEBEB' }}>
									<FontAwesomeIcon icon={faLock} />
								</InputGroup.Text>
								<FormControl
									placeholder={t('update_profile.confirm_password')}
									style={{ borderLeft: '0px', borderColor: '#EBEBEB' }}
									type={showConfPass ? 'text' : 'password'}
									value={confirmPw}
									onChange={event => setConfirmPw(event.target.value)}
									required
									pattern='.{8,}'
								/>

								<InputGroup.Text style={{ backgroundColor: 'white', borderBottomRightRadius: '10px', borderLeft: '0px', borderTopRightRadius: '10px', borderColor: '#EBEBEB' }}>
									{showConfPass ? <FontAwesomeIcon icon={faEyeSlash} onClick={() => setShowConfPass(false)} /> : <FontAwesomeIcon icon={faEye} onClick={() => setShowConfPass(true)} />}
								</InputGroup.Text>
							</InputGroup>
							{show && <Form.Text className='text-danger'>{t('update_profile.pass_not_match')}</Form.Text>}
						</Col>
					</Row>
					<Form.Check type='checkbox'>
						<Form.Check.Input
							type='checkbox'
							required
						/>
						<Form.Check.Label>
							{t('update_profile.by_clicking_register')}&nbsp;
							<a target='_blank' href='/privacy-policy'>
								{t('update_profile.privacy_policy')}
							</a>&nbsp;
							{t('update_profile.and')}&nbsp;
							<a target='_blank' href='/terms-of-use'>
								{t('update_profile.terms_of_use')}
							</a>
						</Form.Check.Label>
					</Form.Check>
					<hr className='mt-4 mb-4' />
				</>
			)}

			<Row className='mt-3'>
				<Col>
					<Button
						variant='link'
						className='text-black'
						onClick={() => setCurrentStep(3)}
					>
						{t('update_profile.back')}
					</Button>
				</Col>
				<Col className='pull-right'>
					<Button
						type='submit'
						className='text-white'
						disabled={user.email === null && disable ? true : false}
					>
						{t('update_profile.complete')}
					</Button>
				</Col>
			</Row>

			<Alert
				variant='dark'
				show={showLoading}
				className='text-center'
				style={{ width: '19em', position: 'fixed', top: '5%', left: '50%', marginTop: '-13px', marginLeft: '-10em' }}
			>
				<Spinner animation='border' variant='primary' />
				<h5 style={{ display: 'inline', marginLeft: '1em' }}>{t('update_profile.creating_your_profile')}</h5>
			</Alert>
		</Form>
	)
}
